import { LayoutDrawerPosition, type LayoutDrawerProps } from './layout-drawer.types.ts';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button } from '@progress/kendo-react-buttons';
import { faArrowLeft, faArrowRight } from '@fortawesome/free-solid-svg-icons';
import styles from './layout-drawer.module.scss';

export function LayoutDrawer({ children, title, position, width, maxWidth, open, onOpen }: LayoutDrawerProps) {
  return (
    <div
      className={`${styles.container} ${open ? styles.open : styles.collapsed}`}
      style={{ width: open ? width : undefined, maxWidth: maxWidth }}
    >
      <div className={styles.header}>
        {open && <span>{title}</span>}
        <Button title={open ? `Close ${title}` : `Open ${title}`} className={styles.headerBtn} onClick={onOpen}>
          {position === LayoutDrawerPosition.Left ? (
            <FontAwesomeIcon icon={open ? faArrowLeft : faArrowRight} size={'sm'} />
          ) : (
            <FontAwesomeIcon icon={open ? faArrowRight : faArrowLeft} size={'sm'} />
          )}
        </Button>
      </div>
      <div className={styles.content}>{open && children}</div>
    </div>
  );
}
